import React, {Fragment} from "react";
import {Outlet} from "react-router-dom";
import {IS_OFF_SEASON_ENABLED} from "data/constants";
import {Footer} from "views/components/footer/footer.component";
import {OffSeasonHeader} from "views/components/header/off_season_header.component";
import {OffSeasonForm} from "views/components/off_season_form/off_season_form.component";
import {Exist} from "views/components/exist/exist.component";
import {Main} from "./main_layout.component";

interface IOffSeasonLayout {
	isWidget?: boolean;
}

export const OffSeasonLayout: React.FC<IOffSeasonLayout> = ({isWidget}) => {
	if (!IS_OFF_SEASON_ENABLED) {
		return <Outlet />;
	}

	return (
		<Fragment>
			<Exist when={!isWidget}>
				<OffSeasonHeader />
			</Exist>
			<Main>
				<OffSeasonForm />
			</Main>
			<Exist when={!isWidget}>
				<Footer />
			</Exist>
		</Fragment>
	);
};
